<template>
  <div class="container">
    <van-list
      style="width: 100%"
      v-model="loading"
      :finished="finished"
      finished-text="— 我是有底线的 —"
      @load="onLoad"
    >
      <div
        class="article-collection-list-item"
        v-for="item in list"
        :key="item.articleId"
        @click="onArticleClick(item)"
        style="margin: 15px 0"
      >
        <div style="position: relative">
            <!-- 0 付费 1 公开 -->
            <img v-if="!item.isFree" style="width: 22px;height: 10px;position: absolute;right: 6px;top: 6px"
            :src="require('../../../assets/imgs/collect/collect_vip.png')" />
            <img v-if="item.isFree" style="width: 22px;height: 10px;position: absolute;right: 6px;top: 6px"
            :src="require('../../../assets/imgs/collect/collect_free.png')" />
          <img
            class="article-collection-list-item-image"
            :src="item.subImageUrl"
          />
        </div>
        <div class="list-item-text-container">
          <div v-if="item.titleCn" class="article-item-title-cn">{{ item.titleCn.replace(/&nbsp;/g, ' ') }}</div>
          <div v-if="item.title" class="article-item-title-en">{{ item.title.replace(/&nbsp;/g, ' ') }}</div>
          <img v-if="item.isRead" style="width: 40px;height: 18px;margin-top: 4px;"
              :src="require('../../../assets/imgs/collect/collect_readed.png')" />
        </div>
      </div>
      <template #finished>
        <div style="font-size: 10px">— 我是有底线的 —</div>
      </template>
    </van-list>
  </div>
</template>

<script>
import moment from "moment";
import { getArticleList } from "@/api/article";
export default {
  name: "ArticleList",
  props: {
    extensionType: {
      type: Number,
      default: 1,
    },
  },
  components: {
    // DateLabel,
  },
  data() {
    return {
      loading: false,
      finished: false,
      pageSize: 10,
      pageIndex: 1,
      list: [],
    };
  },
  activated: {},
  mounted() {},
  methods: {
    onLoad() {
      getArticleList({
        extensionType: this.extensionType,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      })
        .then((result) => {
          this.list = _.concat(this.list, result.data.records);
          this.pageIndex++;
          console.log("recommendList ===>", result);
          console.log("recommendList ===>", this.list);
          this.loading = false;
          if (result.data.records.length < this.pageSize) {
            this.finished = true;
          }
        })
        .catch(() => {});
    },
    onArticleClick(item) {
      this.$router.push({
        path: "/articleGuide",
        query: { articleId: item.articleId },
      });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container {
  padding: 0 3vw;
  display: flex;
}

.article-image-container {
  display: flex;
  position: relative;
  text-align: center;
}

.article-intro-image {
  position: relative;
  width: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.article-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12vw;
  height: 12vw;
  transform: translate(-50%, -50%);
}

.article-catagory {
  margin: 24px 0;
  font-size: 13px;
  color: #999999;
  font-family: serif, SimSun, STSong;
}

.article-desc-en {
  margin: 0 15px;
  margin-bottom: 24px;
  font-size: 14px;
  color: #333333;
  font-family: Helvetica, Arial, sans-serif;
}

.article-desc-cn {
  margin-bottom: 24px;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  font-family: serif, SimSun, STSong;
}

.article-source {
  margin-bottom: 38px;
  font-size: 11px;
  color: #999999;
  font-family: serif, SimSun, STSong;
}

.card-container {
  width: 100%;
}

.article-collection-list-item {
  height: 82px;
  width: 100%;
  display: flex;
  margin: 10px 0;
}

.article-collection-list-item-image {
  width: 82px;
  height: 82px;
  border-radius: 6px;
}

.list-item-text-container {
  justify-content: center;
  display: flex;
  margin-left: 10px;
  flex-direction: column;
}

.article-item-title-cn {
  font-family: serif, SimSun, STSong;
  margin-bottom: 6px;
  font-weight: bold;
  font-size: 12px;
}

.article-item-title-en {
  font-size: 11px;
  font-family: serif, SimSun, STSong;
}

.article-collection-title {
  margin: 24px 0;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-desc {
  margin: 24px 0;
  font-size: 12px;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-tag {
  margin: 24px 0;
  font-size: 10px;
  color: #3994E7;
  font-family: serif, SimSun, STSong;
}

.article-collection-more {
  margin: 10px 0 20px 0;
  color: #3994E7;
}
</style>


// WEBPACK FOOTER //
// app/pages/tabs/Home/ArticleList.vue